import "../../stylesheets/App.css";
import "../../stylesheets/StageItem.css";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

function StageItem(props) {
  const stage = props.stage;

  // Evita crash si todavía no cargó stage
  if (!stage) return null;

  const filterString = stage.active === 0 ? "grayscale(100%)" : "none";

const banner =
  stage.name === "Mis puntos"
    ? `url(${process.env.PUBLIC_URL}/images/stage_banners/bg_mispuntos.png)`
    : stage.name === "Ranking global"
      ? `url(${process.env.PUBLIC_URL}/images/stage_banners/bg_ranking.png)`
      : `url(${process.env.PUBLIC_URL}${stage.background_url})`;
      
  const background = {
    backgroundImage: banner,
    filter: filterString,
  };

  const onClickHandler =
    props.function_onclick && props.function_onclick !== ""
      ? props.function_onclick
      : undefined;

  return (
    <div
      style={background}
      onClick={onClickHandler}
      className="stage-item-container inline-block p-2 cursor-pointer hover:scale-105 ease-in-out duration-300"
    >
      {props.is_ranking && stage.active === 1 && (
        <div className="ranking-float-container">
          <FontAwesomeIcon icon={solid("chevron-right")} size={"sm"} />
          <p className="ranking-float-text">Ver Ranking</p>
        </div>
      )}

      {props.is_stage && stage.active === 1 && (
        <div className="ranking-float-container">
          <FontAwesomeIcon icon={solid("chevron-right")} size={"sm"} />
          <p className="ranking-float-text">
            Ver todos
            <br />
            los partidos
          </p>
        </div>
      )}

      <div className="stage-title-container">
        <h1 className="stage-title">{stage.name}</h1>
        {props.total ? (
          <p className="stage-title-total">Total: {props.total} puntos</p>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default StageItem;
